<script>
  export let appearance = 'primary';
  export let size = 'normal';
  export let disabled = false;
  export let testid = undefined;
  export let download = undefined;
  export let href;
  export let external = false;
  export let target = external ? '_blank' : undefined;
  export let rel = external ? 'noreferrer' : undefined;
</script>

<a class={`link-button appearance-${appearance} size-${size}`} class:disabled {href} {target} {rel} {download} data-cy={testid}>
  <slot />
</a>

<style lang="postcss">
  a {
    padding: 0 var(--spacing--s);
    max-width: 100%;
    width: var(--LinkButton--width);
    height: var(--size--control);
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: var(--radius--m);
    border: none;
    cursor: pointer;
    font: var(--font--outfit-title-14);
    box-sizing: border-box;
    transition: background-color var(--duration--fast) var(--ease--on-screen);

    &.disabled {
      --Icon--color: var(--color--disabled--text);

      color: var(--color--disabled--text);
      background-color: var(--color--disabled--background);
      pointer-events: none;
    }

    &:not(.disabled) {
      &:hover { background-color: var(--Button--hover); }
      &:active { background-color: var(--Button--active); }
    }
  }

  .size-slim {
    height: 32px;
    border-radius: var(--radius--s);
    font: var(--font--outfit-title-12);
  }

  .appearance-primary {
    color: var(--color--primary--text);
    background-color: var(--color--primary--background);

    --Button--hover: var(--color--primary--hover);
    --Button--active: var(--color--primary--active);
    --Icon--color: var(--color--primary--text);
  }

  .appearance-secondary,
  .appearance-icon {
    color: var(--color--secondary--text--text);
    background-color: var(--color--secondary--background);
    border: 1px solid var(--Button--color-border);

    --Button--hover: var(--color--secondary--hover);
    --Button--active: var(--color--secondary--active);
    --Button--color-border: var(--color--grey-30);
    --Icon--color: var(--color--secondary--text);

    &.disabled {
      border: 1px solid var(--color--grey-10);
    }
  }

  .appearance-icon {
    border-radius: var(--radius--circle);
    padding: 0;
    width: var(--size--control);
    font-size: var(--size--icon);
    text-decoration: none;

    &.size-slim { width: 32px; }
  }
</style>
